import api from 'api/api.config';

export const getAllWidgets = ({ userId }) => api.get(`/${userId}/user-widgets`);

export const getWidget = ({ userId, id }) =>
  api.get(`/${userId}/user-widgets/${id}`);
